// Single source of truth for project status presentation.
// `tone` maps to a StatusPill visual variant and to filter styling.
export const PROJECT_STATUS = {
  'now-selling':        { label: 'Now Selling',        tone: 'live' },
  'coming-soon':        { label: 'Coming Soon',        tone: 'pending' },
  'under-construction': { label: 'Under Construction', tone: 'progress' },
  'sold-out':           { label: 'Sold Out',           tone: 'closed' },
  completed:            { label: 'Completed',          tone: 'done' },
};

// Order used by the Projects page filter row (when filters are switched on).
export const STATUS_FILTERS = [
  { id: 'all',          label: 'All Projects' },
  { id: 'now-selling',  label: 'Now Selling' },
  { id: 'coming-soon',  label: 'Coming Soon' },
  { id: 'completed',    label: 'Completed' },
];

export const getStatus = (id) =>
  PROJECT_STATUS[id] ?? { label: id, tone: 'pending' };
